// Configuration Supabase pour les notes persistantes
// Créez un projet sur https://supabase.com et ajoutez vos clés

import { createClient } from '@supabase/supabase-js';

// Configuration - À REMPLACER avec vos vraies clés Supabase
const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || 'https://your-project.supabase.co';
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || 'your-anon-key';

// Créer le client Supabase
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

// Vérifier si Supabase est configuré
export const isSupabaseConfigured = () => {
    return SUPABASE_URL !== 'https://your-project.supabase.co' &&
        SUPABASE_ANON_KEY !== 'your-anon-key';
};

export default supabase;
